import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled border-top pt-3" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1 ms-2 position-relative top-2" }
const _hoisted_8 = { class: "mb-0 fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30\"><h3 class=\"mb-0\">Top Performer</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Month</option><option value=\"1\">Last Month</option><option value=\"2\">Last Year</option></select></div>", 1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.slice(0, 5), (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-flex align-items-center justify-content-between border-bottom pb-3 mb-3",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.user.image,
                  class: "wh-44 rounded-circle",
                  alt: "user"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h6", _hoisted_8, _toDisplayString(item.user.name), 1),
                _createElementVNode("span", null, _toDisplayString(item.user.email), 1)
              ])
            ]),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
              ]))]),
              _: 1
            })
          ]))
        }), 128))
      ]),
      _createVNode(_component_PaginationTwo, {
        items: "5",
        total: "12"
      })
    ])
  ]))
}